import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'services/translation';

import { FormFooter } from './FormFooter';
import { Heading, Subheading, FormContainer, InlineLink } from './styles_auth';
import { LOGIN, SIGNUP_REQUEST } from './routes';

export const InvalidToken = ({ lang }) => {
  const renderRequestNewInvitationLink = () => {
    if (lang.includes('en')) {
      return (
        <span>
          Please{' '}
          <InlineLink to={SIGNUP_REQUEST}>request a new invitation</InlineLink>{' '}
          to complete your portal registration.
        </span>
      );
    }
    return (
      <InlineLink to={SIGNUP_REQUEST}>
        {t(
          'PLEASE_REQUEST_A_NEW_INVITATION_TO_COMPLETE_YOUR_PORTAL_REGISTRATION'
        )}
      </InlineLink>
    );
  };

  const renderLoginLink = () => {
    if (lang.includes('en')) {
      return (
        <span>
          If you have already registered, please{' '}
          <InlineLink to={LOGIN}>log in here</InlineLink>.
        </span>
      );
    }
    return (
      <InlineLink to={LOGIN}>
        {t('IF_YOU_HAVE_ALREADY_REGISTERED_PLEASE_LOG_IN_HERE')}
      </InlineLink>
    );
  };

  return (
    <FormContainer>
      <Heading bold>{t('SORRY_THIS_LINK_HAS_EXPIRED')}</Heading>
      <Subheading>
        {renderRequestNewInvitationLink()}
        <br />
        <br />
        {renderLoginLink()}
      </Subheading>
      <br />
      <br />
      <FormFooter />
    </FormContainer>
  );
};

InvalidToken.propTypes = { lang: PropTypes.string };
InvalidToken.defaultProps = { lang: 'en-US' };
